<template lang="pug">
.container.col-centered
  .row
    h2.main_title
      | Documentation
      .pull-right
        button.btn.btn-primary(@click='openAddDoc')
          span.glyphicon.glyphicon-plus
          span  New
    .col-md-12.function_bar(style='display: flex; justify-content: space-between; align-items: center;')
      .form-group
        label.control_label(style='margin-right: 6px;') Search:
        tooltip(effect='scale' placement='bottom' content='Search by Title or Product(s) / Platform')
          input.form-control(style='display: inline-block; width: 240px;' v-model='temporarySearchQuery' @keydown.enter='applySearchQuery' placeholder='Search...')
      .form-group
        label.control_label(style='margin-right: 6px;') Type:
        v-select(v-bind:value.sync='filterType' v-bind:options='filterTypeOpts')
    spinner(v-ref:spinner size='md' show='true' text='Loading...')
    pagination(
      v-bind:count-of-page.sync='countOfPage'
      v-bind:curr-page.sync='currPage'
      v-bind:count-of-pagination='countOfPagination'
      v-bind:curr-pagination-sec.sync='currPaginationSec'
      v-bind:target-ary.sync='filteredDocs'
    )
    .col-md-12
      table.table.table-bordered.table-hover(style='table-layout: fixed;')
        colgroup
          col(style='width: 5%;')
          col(style='width: 13%;')
          col
          col(style='width: 25%;')
          col(style='width: 15%;')
          col(style='width: 15%;')
        thead
          tr
            th #
            th Type
            th Title
            th Product(s) / Platform
            th Created At
            th Action
        tbody
          tr(v-if='filteredDocs.length === 0')
            td.text-center.text-muted(colspan='6') No documentation available.
          tr(v-for='($index, doc) in filteredDocs | limitBy countOfPage pageStart')
            td.text-vcenter {{$index + 1 + pageStart}}
            td.text-vcenter: span.label(v-bind:style="{backgroundColor: typeColor(doc.type), color: '#fff'}") {{typeLabel(doc.type)}}
            td.text-vcenter(style='white-space: normal; word-break: break-word;' v-html='highlightMatches(doc.title, searchQuery)')
            td.text-vcenter(style='white-space: normal; word-break: break-word;')
              template(v-if='productList(doc).length')
                ul.product-list(v-if='isPerProductType(doc.type)')
                  li(v-for='p in productList(doc)' v-html='highlightMatches(p, searchQuery)')
                span(v-else v-html='highlightMatches(productList(doc)[0], searchQuery)')
              span.text-muted(v-else) —
            td.text-vcenter {{ doc.createdAt | fromNow }}
            td.text-vcenter.text-center(style='white-space: nowrap;')
              .btn-group
                button.btn.btn-sm.btn-default(@click='handleDownload(doc.url)' v-bind:disabled='!doc.url')
                  span.glyphicon.glyphicon-cloud-download
                  span  Download
                button.btn.btn-sm.btn-default(@click='openEditDoc(doc)')
                  span.glyphicon.glyphicon-pencil
                button.btn.btn-sm.btn-default(@click='deleteDoc(doc[".key"])')
                  span.glyphicon.glyphicon-trash

modal(title='Confirm' v-bind:show.sync='showDeleteConfirm')
  .modal-body(slot='modal-body')
    h4.text-center Are you sure to delete?
  .modal-footer(slot='modal-footer')
    button.btn.btn-default(@click='showDeleteConfirm = false') No
    button.btn.btn-danger(@click='applyDelete') Yes

modal(v-bind:title="editingDocKey ? 'Edit Documentation' : 'New Documentation'" v-bind:show.sync='showDocModal' effect='fade' backdrop='false')
  .modal-body(slot='modal-body')
    .col-md-12.clearfix.col-centered
      .form-group.col-md-12.clearfix
        .col-md-3.form-label.clearfix
          label.control_label Type:
        .col-md-9.no_pad.clearfix
          v-select(v-bind:value.sync='docForm.type' v-bind:options='typeOpts')
      .form-group.col-md-12.clearfix
        .col-md-3.form-label.clearfix
          label.control_label Title:
        .col-md-9.no_pad.clearfix
          input.form-control(v-model='docForm.title' placeholder='Required')
      .form-group.col-md-12.clearfix(v-show="isPerProductType(docForm.type)")
        .col-md-3.form-label.clearfix
          label.control_label Category:
        .col-md-9.no_pad.clearfix
          v-select(v-bind:value.sync='categoryFilter' v-bind:options='categoryOpts')
      .form-group.col-md-12.clearfix
        .col-md-3.form-label.clearfix
          label.control_label {{isPerProductType(docForm.type) ? 'Product(s):' : 'Platform:'}}
        .col-md-9.no_pad.clearfix
          v-select(v-bind:multiple="isPerProductType(docForm.type)" v-bind:value.sync='docForm.products' v-bind:options='productOpts')
      .form-group.col-md-12.clearfix
        .col-md-3.form-label.clearfix
          label.control_label URL:
        .col-md-9.no_pad.clearfix
          input.form-control(v-model='docForm.url' placeholder='https://drive.google.com/file/d/.../view')
  .modal-footer(slot='modal-footer')
    button.btn.btn-default(@click='showDocModal = false') Cancel
    button.btn.btn-primary(@click='saveDoc' v-bind:disabled='isDocFormInvalid') {{editingDocKey ? 'Update' : 'Add'}}
</template>

<script>
import { spinner, select, modal, tooltip } from 'vue-strap'
import { getDb, getDbTime, filterOptions, documentTypeOptions, documentTypeLabelMap, documentTypeColor, resolveDownloadUrl, getLabelFromCategory } from '../../index.js'
import _ from 'lodash'
import pagination from '../common/Pagination.vue'
import searchMixin from '../../mixins/searchMixin.js'

export default {
  name: 'Documentation',
  mixins: [searchMixin],
  components: {
    spinner,
    'v-select': select,
    pagination,
    modal,
    tooltip
  },
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  data () {
    return {
      docs: [],
      productsByCategory: [],
      filterType: 'any',
      filterTypeOpts: [{ label: 'Any', value: 'any' }, ...documentTypeOptions],
      temporarySearchQuery: '',
      searchQuery: '',
      typeOpts: documentTypeOptions,
      categoryOpts: filterOptions.category,
      categoryFilter: null,
      showDocModal: false,
      showDeleteConfirm: false,
      pendingDeleteKey: null,
      docForm: { type: 'qig', title: '', products: [], url: '' },
      editingDocKey: null,
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1
    }
  },
  ready () {
    this._productCache = {}
    this.$refs.spinner.show()
    getDb().ref('documentation').orderByChild('createdAt').on('value', sn => {
      this.docs = _.transform(sn.val(), (result, value, key) => {
        result.push({ '.key': key, ...value })
      }, []).reverse()
      this.$refs.spinner.hide()
    }, err => {
      console.error('documentation read error:', err)
      this.$refs.spinner.hide()
    })
  },
  computed: {
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    productOpts () {
      if (this.isPerProductType(this.docForm.type)) {
        return this.productsByCategory
      }
      if (this.docForm.type === 'upgrade_guide') {
        return [...filterOptions.category, { label: 'InstaViewer', value: 'viewer' }]
      }
      return filterOptions.category
    },
    filteredDocs () {
      let result = this.docs
      if (this.filterType !== 'any') {
        result = result.filter(d => d.type === this.filterType)
      }
      if (this.searchQuery.trim()) {
        const q = this.searchQuery.toLowerCase()
        result = result.filter(d =>
          (d.title && d.title.toLowerCase().includes(q)) ||
          this.productDisplay(d).toLowerCase().includes(q)
        )
      }
      return result
    },
    isDocFormInvalid () {
      return !this.docForm.title.trim() || !this.docForm.products.length || !this.docForm.url.trim()
    }
  },
  methods: {
    typeLabel (type) {
      return documentTypeLabelMap[type] || type
    },
    typeColor (type) {
      return documentTypeColor[type] || '#777777'
    },
    isPerProductType (type) {
      return ['datasheet', 'qig'].includes(type)
    },
    productList (doc) {
      const products = Object.values(doc.products || {})
      if (this.isPerProductType(doc.type)) { return products }
      return products.map(v => getLabelFromCategory(v))
    },
    productDisplay (doc) {
      return this.productList(doc).join(', ')
    },
    handleDownload (url) {
      if (!url) return
      window.open(resolveDownloadUrl(url))
    },
    loadProductsByCategory (category) {
      if (this._productCache[category]) {
        this.productsByCategory = this._productCache[category]
        return
      }
      getDb().ref('product').orderByChild('category').equalTo(category).once('value', sn => {
        const opts = _.transform(sn.val(), (result, value, key) => {
          if (value.custom && value.custom['intrising']) result.push({ label: key, value: key })
        }, [])
        this._productCache[category] = opts
        this.productsByCategory = opts
      })
    },
    openAddDoc () {
      this.docForm = { type: 'qig', title: '', products: [], url: '' }
      this.categoryFilter = null
      this.editingDocKey = null
      this.showDocModal = true
    },
    openEditDoc (doc) {
      const savedProducts = Object.values(doc.products || {})
      this.docForm = {
        type: doc.type,
        title: doc.title,
        products: [],
        url: doc.url || ''
      }
      this.categoryFilter = (this.isPerProductType(doc.type) && doc.productCategory) ? doc.productCategory : null
      this.editingDocKey = doc['.key']
      this.showDocModal = true
      this.$nextTick(() => {
        this.docForm.products = savedProducts
      })
    },
    saveDoc () {
      const { type, title, url } = this.docForm
      const products = this.isPerProductType(type) ? this.docForm.products : [this.docForm.products]
      const data = { type, title, products, url }
      if (this.isPerProductType(type)) data.productCategory = this.categoryFilter
      if (this.editingDocKey) {
        getDb().ref('documentation').child(this.editingDocKey).update(data)
      } else {
        getDb().ref('documentation').push({ ...data, createdAt: getDbTime() })
      }
      this.showDocModal = false
    },
    deleteDoc (key) {
      this.pendingDeleteKey = key
      this.showDeleteConfirm = true
    },
    applyDelete () {
      getDb().ref('documentation').child(this.pendingDeleteKey).remove()
      this.showDeleteConfirm = false
      this.pendingDeleteKey = null
    }
  },
  watch: {
    'docForm.type' () {
      this.docForm.products = []
    },
    categoryFilter (category) {
      this.docForm.products = []
      this.productsByCategory = []
      if (category) { this.loadProductsByCategory(category) }
    },
    showDocModal (val) {
      if (!val) {
        this.docForm = { type: 'qig', title: '', products: [], url: '' }
        this.categoryFilter = null
        this.editingDocKey = null
      }
    },
    filterType () {
      this.currPage = 1
      this.currPaginationSec = 1
    },
    searchQuery () {
      this.currPage = 1
      this.currPaginationSec = 1
    }
  }
}
</script>

<style scoped lang="scss">
.text-vcenter {
  vertical-align: middle;
}
.product-list {
  margin: 0;
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// Documentation.vue?0cb1e99e